import { FC } from 'react';
import {
  ButtonGroup as MuiButtonGroup,
  ButtonGroupProps as MuiButtonGroupProps,
} from '@mui/material';

export type ButtonGroupProps = MuiButtonGroupProps;

const ButtonGroup: FC<ButtonGroupProps> = ({ ...props }) => <MuiButtonGroup {...props} />;

export default ButtonGroup;
